function ChangePlaceholder() {

    if ($(window).width() <= 500) {

        $('input[type="email"]').attr("placeholder", "E-posta adresinizi girin");
    } else {

        $('input[type="email"]').attr("placeholder", "E-posta adresinizi girin");
    }
}

// $(window).resize(ChangePlaceholder).trigger('resize');

$(document).ready(function () {

    // ChangePlaceholder();

    $("body").on("submit", "#NewsLetterForm", function () {
        
        $form = $(this);
        $NewsLetterResult = $(".NewsLetterResult");

        $.ajax({
            type: $form.attr("method"),
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: "json",
            success: function (dt) {

                if (dt.Sonuc == true) {

                    AlertObject = dt.JsonRs[0];

                    $(".formItem").hide();
                    $NewsLetterResult.show();
                    $NewsLetterResult.html(AlertObject);
                    //$NewsLetterResult.addClass("alert-success");
                    //$NewsLetterResult.removeClass("alert-danger");
                    $(".NewsletterFormHead").hide();
                    setTimeout(function () { $("#NewsletterPopup").modal("hide"); }, 3000);

                }
                else {

                    $NewsLetterResult.show();
                    //$NewsLetterResult.removeClass("alert-success");

                    if (dt.JsonRs != undefined && dt.JsonRs.length > 0) {
                        //$NewsLetterResult.addClass("alert-danger");
                        $NewsLetterResult.html(dt.JsonRs[0]);
                        $(".NewsletterFormHead").hide();
                    }
                    else if (dt.IslemSonucAciklama != null || dt.IslemSonucAciklama != "") {

                        //$NewsLetterResult.addClass("alert-danger"); 
                        $NewsLetterResult.html(dt.IslemSonucAciklama);
                        $(".NewsletterFormHead").hide();
                    }


                    //setTimeout(function () { $("#NewsletterPopup").modal("hide"); }, 3000);

                }

            },
            error: function (a) {
                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });

        return false;


    });

});

